import { EmployeeDepartment } from '@entities/event/lib/hooks/useFetchSegmentTree';
import { Ticket } from '@pages/event/api/useFetchTicketSegment';

const norm = (s?: string | null) => (s ?? '').toLowerCase().trim();

const isTicketMatch = (t: Ticket, q: string) => {
  if (!q) return true;
  const fn = norm(t.participant?.firstName);
  const ln = norm(t.participant?.lastName);
  if (!fn && !ln) return false;
  const full = `${fn} ${ln}`;
  const reversed = `${ln} ${fn}`;
  return full.includes(q) || reversed.includes(q) || fn.includes(q) || ln.includes(q);
};

export const pruneDepartment = (dep: EmployeeDepartment, q: string): EmployeeDepartment | null => {
  const tickets = (dep.tickets ?? []).filter((t) => isTicketMatch(t, q));

  const childDepartment = (dep.childDepartment ?? [])
    .map((child) => pruneDepartment(child, q))
    .filter(Boolean) as EmployeeDepartment[];

  if (q && tickets.length === 0 && childDepartment.length === 0) return null;

  return q ? { ...dep, tickets, childDepartment } : dep;
};
